import React from 'react'

const CountryAvailabilityList = () => {
  const countries = [
    'Australia',
    'Austria',
    'Belgium',
    'Bulgaria',
    'Canada',
    'China',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Hong Kong',
    'Hungary',
    'Ireland',
    'Italy',
    'Japan',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Romania',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
    'United Kingdom',
    'United States',
  ]

  return (
    <div>
      <ul>
        {countries.map((country, index) => (
          <li key={index}>{country}</li>
        ))}
      </ul>
    </div>
  )
}

export default CountryAvailabilityList
